module.exports = __webpack_public_path__ + "img/au.svg";